import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FieldLabel from "../FieldLabel/FieldLabel";
import "./HeightInput.scss";

// Unit picker rendered as a startAdornment inside one OutlinedInput, so the
// whole control is a single MUI field (one border, one height) instead of
// two separate boxes trying to look like one. unit/onUnitChange are
// controlled by the parent so the selected unit can be saved with the form.
const HeightInput = ({
  type,
  value,
  title,
  options,
  onChange,
  name,
  unit,
  onUnitChange,
  placeholder,
}) => {
  return (
    <div className="height-input">
      {title && <FieldLabel htmlFor={name}>{title}</FieldLabel>}
      <OutlinedInput
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        fullWidth
        startAdornment={
          <InputAdornment position="start" className="height-input_unit">
            <Select
              variant="standard"
              disableUnderline
              value={unit || options[0].value}
              onChange={onUnitChange}
            >
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </InputAdornment>
        }
      />
    </div>
  );
};

export default HeightInput;
